import React from "react";

const Blog = () => {
   return (
      <div style={{ backgroundColor: "black" }}>
         <div style={{ paddingTop: "250px", paddingBottom: "425px", overflow: "hidden" }}>
            <h1 className="text-center text-white">Blog Will Be Coming Soon </h1>
         </div>
      </div>
   );
};

export default Blog;
